function initCsh(section) {
  var track = section.querySelector('.wh-csh__track');
  var prevBtn = section.querySelector('.wh-csh__btn--prev');
  var nextBtn = section.querySelector('.wh-csh__btn--next');
  if (!track) return;

  var originalCards = Array.from(track.querySelectorAll('.wh-csh__card'));
  var total = originalCards.length;
  if (total === 0) return;

  function visibleCount() {
    return window.innerWidth <= 600 ? 2 : window.innerWidth <= 900 ? 3 : 4;
  }

  var vis = visibleCount();

  // Kitne clones chahiye: kam se kam vis*3 cards total mein hone chahiye
  // Taaki loop seamless ho aur blank na aaye
  var totalNeeded = vis * 3;
  var clonesNeeded = Math.ceil(totalNeeded / total) * total;

  // End clones
  for (var i = 0; i < clonesNeeded; i++) {
    var ce = originalCards[i % total].cloneNode(true);
    ce.setAttribute('data-clone', 'e');
    track.appendChild(ce);
  }
  // Start clones
  for (var j = clonesNeeded - 1; j >= 0; j--) {
    var cs = originalCards[j % total].cloneNode(true);
    cs.setAttribute('data-clone', 's');
    track.insertBefore(cs, track.firstChild);
  }

  var state = {
    index: 0,
    cardW: 0,
    clones: clonesNeeded,
    animating: false
  };

  // Card width: pehle rendered card se lo — CSS jo bhi set kare
  function getCardW() {
    // Sabse pehle actual DOM se card width lo
    var cards = Array.from(track.querySelectorAll('.wh-csh__card'));
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.width > 10) {
        // gap CSS se lo
        var trackStyles = getComputedStyle(track);
        var gap = parseFloat(trackStyles.gap) || parseFloat(trackStyles.columnGap) || 16;
        return rect.width + gap;
      }
    }
    return 0;
  }

  function calcOffset() {
    return -((state.clones + state.index) * state.cardW);
  }

  function applyTransform(px, animated) {
    track.style.transition = animated ? 'transform 0.4s ease' : 'none';
    track.style.transform = 'translateX(' + px + 'px)';
  }

  var initAttempts = 0;
  function init() {
    vis = visibleCount();
    state.cardW = getCardW();

    if ((!state.cardW || state.cardW < 10) && initAttempts < 15) {
      initAttempts++;
      setTimeout(init, 100);
      return;
    }

    // KUCH BHI OVERRIDE MAT KARO — sirf transform lagao
    applyTransform(calcOffset(), false);
  }

  function updateDots() {
    var dotsContainer = section.querySelector('.wh-csh__dots');
    if (!dotsContainer) return;
    var dots = Array.from(dotsContainer.querySelectorAll('.wh-csh__dot'));
    if (!dots.length) return;
    var dotTotal = dots.length;
    var dotIndex = ((state.index % dotTotal) + dotTotal) % dotTotal;
    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === dotIndex);
    });
  }

  // Init: page load ke baad karo taaki cards render ho jaayein
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
  // Extra safety timeout
  setTimeout(function() {
    if (!state.cardW || state.cardW < 10) {
      initAttempts = 0;
      init();
    }
  }, 500);

  updateDots();

  var dotsContainer = section.querySelector('.wh-csh__dots');
  if (dotsContainer) {
    var prevDot = dotsContainer.querySelector('.wh-csh__dot--prev');
    var nextDot = dotsContainer.querySelector('.wh-csh__dot--next');
    if (prevDot) prevDot.addEventListener('click', function() { stopAuto(); goTo(state.index - 1); });
    if (nextDot) nextDot.addEventListener('click', function() { stopAuto(); goTo(state.index + 1); });
  }

  setTimeout(function() {
    track.querySelectorAll('[data-clone] .card-group-swatches').forEach(function(el) {
      el.removeAttribute('data-loaded');
      el.removeAttribute('data-closeup-loaded');
    });
    if (window.initGroupSwatches) window.initGroupSwatches();
  }, 300);

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      state.cardW = 0;
      initAttempts = 0;
      init();
    }, 150);
  });

  function goTo(idx) {
    if (state.animating) return;
    state.index = idx;
    state.animating = true;
    applyTransform(calcOffset(), true);
    updateDots();

    setTimeout(function() {
      state.animating = false;
      if (state.index >= total) {
        state.index = state.index % total;
        applyTransform(calcOffset(), false);
      } else if (state.index < 0) {
        state.index = ((state.index % total) + total) % total;
        applyTransform(calcOffset(), false);
      }
      updateDots();
    }, 420);
  }

  var autoTimer;
  function startAuto() {
    stopAuto();
    autoTimer = setInterval(function() { goTo(state.index + 1); }, 3000);
  }
  function stopAuto() {
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); goTo(state.index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); goTo(state.index + 1); });

  var drag = { active: false, moved: false, startX: 0, startY: 0, startOffset: 0 };

  function onStart(x, y) {
    drag.active = true;
    drag.moved = false;
    drag.startX = x;
    drag.startY = y || 0;
    drag.startOffset = calcOffset();
    track.classList.add('is-dragging');
    stopAuto();
    track.style.transition = 'none';
  }

  function onMove(x) {
    if (!drag.active) return;
    var diff = x - drag.startX;
    if (Math.abs(diff) > 5) drag.moved = true;
    track.style.transition = 'none';
    track.style.transform = 'translateX(' + (drag.startOffset + diff) + 'px)';
  }

  function onEnd(x) {
    if (!drag.active) return;
    drag.active = false;
    track.classList.remove('is-dragging');
    var diff = x - drag.startX;
    if (drag.moved) {
      var threshold = Math.max(60, state.cardW * 0.25);
      if (diff < -threshold) goTo(state.index + 1);
      else if (diff > threshold) goTo(state.index - 1);
      else applyTransform(calcOffset(), true);
    } else {
      applyTransform(calcOffset(), true);
    }
  }

  track.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return;
    onStart(e.clientX, e.clientY);
    e.preventDefault();
  });
  window.addEventListener('mousemove', function(e) { if (drag.active) onMove(e.clientX); });
  window.addEventListener('mouseup', function(e) { if (drag.active) onEnd(e.clientX); });

  track.addEventListener('touchstart', function(e) {
    onStart(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });

  track.addEventListener('touchmove', function(e) {
    if (!drag.active) return;
    var diffX = Math.abs(e.touches[0].clientX - drag.startX);
    var diffY = Math.abs(e.touches[0].clientY - drag.startY);
    if (diffX > diffY && diffX > 8) e.preventDefault();
    onMove(e.touches[0].clientX);
  }, { passive: false });

  track.addEventListener('touchend', function(e) {
    onEnd(e.changedTouches[0].clientX);
  }, { passive: true });

  track.addEventListener('touchcancel', function(e) {
    onEnd(e.changedTouches[0].clientX);
  }, { passive: true });

  var wheelTimer = null;
  var wheelLocked = false;
  var trackOuter = section.querySelector('.wh-csh__track-outer');
  if (trackOuter) {
    trackOuter.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) return;
      e.preventDefault();
      if (state.animating || wheelLocked) return;
      stopAuto();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function() { wheelLocked = false; }, 600);
      if (e.deltaX > 30) { wheelLocked = true; goTo(state.index + 1); }
      else if (e.deltaX < -30) { wheelLocked = true; goTo(state.index - 1); }
    }, { passive: false });
  }

  track.addEventListener('click', function(e) {
    if (drag.moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  track.querySelectorAll('img').forEach(function(img) {
    img.addEventListener('dragstart', function(e) { e.preventDefault(); });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.wh-csh[data-csh-id]').forEach(function(section) {
    initCsh(section);
  });
});

document.addEventListener('shopify:section:load', function(e) {
  var section = e.target.querySelector('.wh-csh[data-csh-id]');
  if (section) initCsh(section);
});